import { Modal } from 'rsuite';
import { URL_VIDEO_TUTORIAL } from '../../constants';

interface Props {
  show: boolean;
  onHide: () => void;
}

export function ModalTutorialVideo({ show, onHide }: Props) {
  return (
    <Modal size="lg" className="pp-modal-tutorial" show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>Tutorial Preço Psicológico</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {show && (
          <iframe
            className="pp-modal-tutorial__video"
            src={`${URL_VIDEO_TUTORIAL}?autoplay=1`}
            title="Tutorial Preço Psicológico"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
